import { Field } from 'formik';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Title = styled.h1`
  width: 100%;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 66px;
  text-align: center;
  letter-spacing: 0.02em;
  margin: 0;
  color: ${(props: any) => props.theme.black};
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

const Message = styled.h2`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.charcoal};
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 23px;
  }
`;

const BottomSpan = styled.span`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 16px;
  color: ${(props: any) => props.theme.darkGrey};
`;

const LinkCustom = styled(Link)`
  width: auto;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: ${(props: any) => props.theme.primary};
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 19px;
  }
`;

const LinkExternalCustom = styled.a`
  width: auto;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: ${(props: any) => props.theme.primary};
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 19px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const Question = styled.p`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.black};
  margin: 0px;
  @media (max-width: 620px) {
    text-align: left;
  }
  strong {
    color: ${(props: any) => props.theme.blue};
  }
  b {
    color: ${(props: any) => props.theme.red};
  }
  label {
    color: ${(props: any) => props.theme.grey};
  }
`;

const InputField = styled.input`
  height: 32px;
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.black};
  border: 2px solid ${(props: any) => props.theme.gray};
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 16px;
  padding: 8px;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(props: any) => props.theme.gray};
  }
  :-ms-input-placeholder {
    color: ${(props: any) => props.theme.gray};
  }
`;

const TextAreaField = styled.textarea`
  height: 140px;
  width: 100%;
  flex-grow: 1;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: -0.5px;
  color: ${(props: any) => props.theme.grey700};
  border: 1px solid ${(props: any) => props.theme.grey300};
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px 16px;
  resize: none;
  outline: none;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${(props: any) => props.theme.grey500};
  }
  :-ms-input-placeholder {
    color: ${(props: any) => props.theme.grey500};
  }
`;

const Marker = styled.div`
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  margin-top: 7px;
  margin-right: 8px;
  background-color: ${(props: any) => props.theme.primary};
`;

const WrapperQuestionTitle = styled.div`
  margin-top: 25px;
  display: flex;
  flex-direction: row;
`;

const ButtonSubmit = styled.button`
  min-height: 40px;
  height: 40px;
  width: 206px;
  background: ${(props: any) => props.theme.primaryLight};
  border: 2px solid ${(props: any) => props.theme.primaryLight};
  border-radius: 4px;
  margin-top: 24px;
  margin-bottom: 8px;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  letter-spacing: 0.02em;
  color: ${(props: any) => props.theme.primary};
  cursor: pointer;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ContainerMain = styled.div`
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const Container = styled.div`
  max-width: 800px;
  flex-grow: 1;
`;

const RateNumber = styled(Field)`
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.04em;
  margin-top: 16px;
  margin-bottom: 8px;
  border: 2px solid #dddee0;
  box-sizing: border-box;
  border-radius: 8px;
  color: ${(props: any) => props.theme.black};
  background: ${(props: any) => props.theme.white};
  cursor: pointer;
  opacity: 1;
  -webkit-tap-highlight-color: transparent;
`;

const RateText = styled.p`
  font-family: Heebo, sans-serif;
  font-weight: normal;
  font-size: 11px;
  line-height: 14px;
  display: flex;
  margin: 0px;
  text-align: center;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.gray};
  border-radius: 9px;
  border-style: solid;
  padding-right: 2px;
  padding-left: 2px;
  border-color: ${(props: any) => props.theme.white};
  min-width: 46px;
  justify-content: center;
`;

const RateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 260px;
`;

const RateWrapper = styled.div`
  text-align: center;
  align-items: center;
  -webkit-tap-highlight-color: transparent;
`;

const ValidationMessage = styled.p`
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
  color: ${(props: any) => props.theme.red};
  @media (max-width: 620px) {
    text-align: left;
  }
`;

const SentMessage = styled.p`
  font-family: 'Heebo';
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 13px;
  color: ${(props: any) => props.theme.black};
  a {
    display: inline;
    text-decoration: underline;
    color: inherit;
  }
  @media (max-width: 620px) {
    text-align: left;
  }
`;
export const FormStyled = {
  SentMessage,
  Title,
  Message,
  LinkCustom,
  Wrapper,
  Question,
  InputField,
  Marker,
  WrapperQuestionTitle,
  TextAreaField,
  ButtonSubmit,
  Container,
  ContainerMain,
  RateText,
  RateNumber,
  RateContainer,
  ValidationMessage,
  BottomSpan,
  LinkExternalCustom,
  RateWrapper
};
